import { render, staticRenderFns } from "./allDeviceLithiumDetail.vue?vue&type=template&id=3852fbc9&scoped=true"
import script from "./allDeviceLithiumDetail.vue?vue&type=script&lang=js"
export * from "./allDeviceLithiumDetail.vue?vue&type=script&lang=js"
import style0 from "./allDeviceLithiumDetail.vue?vue&type=style&index=0&id=3852fbc9&prod&lang=scss&scoped=true"
import style1 from "./allDeviceLithiumDetail.vue?vue&type=style&index=1&id=3852fbc9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3852fbc9",
  null
  
)

export default component.exports